











































import { PropType } from 'vue';
import { ErrorManager } from '@/models/error';
import { IEmployeeFetchActionPayload } from '@/store/employee';
import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';
import { Employee, EmployeeType, IEmployeeData } from '@/models';
import { getPropertyFromItem } from '@/utils/helpers';
import { IEmployeeFetchParams, IEmployeePaginatedListData } from '@/services';

export default mixins(Functions).extend({
  name: 'EmployeePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    supervisor: {
      type: Number as PropType<number>
    },

    employeeType: {
      type: Number as PropType<EmployeeType>
    },

    includeInactive: {
      type: Boolean,
      default: () => false
    },

    externalErrorMessage: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      selectedEmployee: null,
      localEmployeesList: [] as IEmployeeData[],
      page: 1,
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any, prevVal: any) {
        this.lazyValue = val;
        if (val) {
          if (val !== prevVal) {
            // search for the correct employee
            const searchQuery = getPropertyFromItem(val, 'fullName', val);

            this.debouncefetchEmployees(searchQuery);
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (this.externalErrorMessage) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  methods: {
    clearAllErrors(): void {
      this.errorMessage = '';
    },

    debouncefetchEmployees(search?: string) {
      this.clearAllErrors();
      // seach input is set to null in v-autocomplete
      if (search === null) return;

      this.loading = true;
      const params: IEmployeeFetchParams = {
        page: 1,
        search: search,
        type: this.employeeType,
        supervisor: this.supervisor
      };

      if (!this.includeInactive) {
        params.is_active = 'true';
      }

      this.debounce(this.searchEmployees, 1000)(params);
    },

    searchEmployees(params: IEmployeeFetchActionPayload) {
      this.loading = true;
      return this.$services.employee
        .fetchEmployees(params)
        .then(data => {
          this.localEmployeesList = (data as IEmployeePaginatedListData).results.map(
            (employee: IEmployeeData) => new Employee(employee)
          );
          if (this.internalValue) {
            const currentEmployee = this.localEmployeesList.find(
              employee =>
                employee.id == this.getEmployeeValue(this.internalValue)
            );

            // Add current employee to list if not in initial list
            if (!currentEmployee) {
              this.$services.employee
                .fetchEmployee(this.getEmployeeValue(this.internalValue))
                .then((data: IEmployeeData) => {
                  this.localEmployeesList.unshift(new Employee(data));
                });
            }
          }
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * removing filter from the employee search as to get the raw data from the server as is
     */
    itemSearch(item: any, queryText: string, itemText: string) {
      return true;
    },

    getEmployeeValue(employee: IEmployeeData) {
      return getPropertyFromItem(employee, 'id', employee);
    }
  }
});
